module.exports = __webpack_public_path__ + "static/media/slide7.d26d89c3.jpg";